// WHAT THE BUSINESS OWES PEOPLE WHO BOUGHT SOMETHING FOR IT — the secretary who paid for
// cakes for a client meeting out of her own pocket (migration 061).
//
// ⚠ ITS OWN CARD, BESIDE THE GAP AND DELIBERATELY NOT INSIDE IT. The gap is a standing
// offset between the two OWNERS: each one's collected cash against what their profit
// share entitles them to, and it balances to zero because every shekel in it belongs to
// one of them. A person who fronted a cost is not a party to that. She holds no share and
// is in no profit, so what she is owed is a liability to a THIRD PARTY — a different kind
// of number about different people, and a line of it inside the gap card would read as a
// term of the gap within a day.
//
// IT CANNOT DOUBLE-COUNT WITH THE GAP, STRUCTURALLY. Every row behind this figure is an
// UNPAID expense, which is exactly the set `settlementCalc` excludes from both of its
// sides — nobody is out of pocket as far as the partnership is concerned, so no debt
// between the owners exists yet. Reimbursing her is what moves the money into the gap, as
// the reimbursing partner's cash on the day it leaves them, and the row drops out of this
// list in the same instant. The two figures describe disjoint sets of rows at every
// moment.
//
// THE CLIENT ADDS NOTHING, which is this screen's rule. `balance.owedToStaff` is computed
// by the server (expenses/service.js `listOwedToStaff`) and was already in the payload
// before this component existed — it was simply dropped on the floor. Nothing here sums,
// rounds or derives; the total on a row is the server's own.
//
// PLAIN ROWS, NOT A TABLE — the same reasoning CollectedList states beside it: a
// two-column table needs two headings and there is nothing to head, since the left side
// is a person and the right side is money. Headings would be furniture.
//
// ROWS CLICK THROUGH TO THE UNPAID EXPENSES, because a statement of a debt that offers no
// way to reach it is where this feature stopped last time. The list is not yet filtered to
// the one person — there is no per-person filter on that screen — so this lands on the
// unpaid view and leaves the narrowing for later. Better an honest one click too many
// than a link that pretends to a filter that does not exist.
import { useNavigate } from 'react-router-dom';
import he from '../../i18n/he';
import Money from '../../components/Money';

export default function OwedToStaff({ rows }) {
  const navigate = useNavigate();

  // NOTHING RENDERS WHEN NOBODY IS OWED, and this is the one card on the screen that
  // hides itself. Every other one answers a question that always has an answer — the gap
  // exists whether or not it is large. This one states a debt, and "we owe nobody" is not
  // a standing fact worth a card of its own on a screen about the partners; an empty card
  // here would be a heading about the secretary on a screen she is usually not part of.
  if (!rows || rows.length === 0) return null;

  return (
    <div className="card settle-card">
      <h2>{he.expenses.owedToStaffTitle}</h2>
      {rows.map((r) => (
        <button
          key={r.userId}
          type="button"
          className="settle-collected-row settle-owed-row"
          onClick={() => navigate('/expenses')}
        >
          {/* Name and how many costs are behind the figure. The count is here because one
              number with no shape invites the question immediately: 180 of what? */}
          <span>{he.expenses.owedToStaffRow(r.userName, r.count)}</span>
          <Money value={r.total} />
        </button>
      ))}
    </div>
  );
}
